import * as t from 'ts-schema';
import { registerQuery } from 'data-fetching-client';
import { getAcademyCertifications } from '../../clients/ecosystemClient';
const providerCertificationsResponseSchema = t.array(t.object({
  awardName: t.string,
  trackIds: t.array(t.number),
  iconUrl: t.string,
  displayNames: t.object({}),
  defaultName: t.string
}));

function getProviderCertifications() {
  return getAcademyCertifications();
}

export const GET_PROVIDER_CERTIFICATIONS = registerQuery({
  fieldName: 'certifications',
  args: [],
  fetcher: getProviderCertifications
});